import React,{useState} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import BlogForm from '../Components/Blogs/BlogForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection } from 'firebase/firestore';
const AddBlog = () => {
    const [blogTitle, setBlogTitle] = useState("")
    const [blogContent, setBlogContent] = useState("")
    const [blogContentOne, setBlogContentOne] = useState("")
    const [coverImage, setCoverImage] = useState("")
    const [bannerImage, setBannerImage] = useState("")
    const [blogWriter, setBlogWriter] = useState("")
    const [blogContentTwo, setBlogContentTwo] = useState("")
    const [blogImageOne, setBlogImageOne] = useState("")
    const [url, setUrl] = useState("")
    const [blogImageTwo, setBlogImageTwo] = useState("")
    const addCoverImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setCoverImage(downloadURL)
         console.log(downloadURL)
       });
     }
   );
    }
    const addBannerImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBannerImage(downloadURL)
         
       });
     }
   );
    }
    const addImageOne = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBlogImageOne(downloadURL)
         
       });
     }
   );
    }
    const addImageTwo = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBlogImageTwo(downloadURL)
         
       });
     }
   );
    }
    const addBlog = () =>{
      const date = new Date()
        addDoc(collection(db, "blogs"),{
       name: blogTitle,
       introContent:blogContent,
       contentOne:blogContentOne,
       imageOne: blogImageOne,
       imageTwo:blogImageTwo,
       contentTwo:blogContentTwo,
       coverImage:coverImage,
       bannerImage:bannerImage,
        createdAt:date,
        url:url
    })
    setBlogContentOne("")
    setBlogTitle("")
    setBlogContent("")
    setBlogContentTwo("")
    setBlogImageOne("")
    setBlogImageTwo("")
    setCoverImage("")
    setBannerImage("")
   
    }
  return (
    <div className=' bg-gray-200  ' >
      <MultiLevelSidebar />
    <BlogForm blogTitle={blogTitle} setBlogTitle={setBlogTitle}
    blogContentOne={blogContentOne} setBlogContentOne={setBlogContentOne}
     blogContent={blogContent} setBlogContent={setBlogContent}
      coverImage={coverImage} setCoverImage={setCoverImage}
    bannerImage={bannerImage} setBannerImage={setBannerImage}
    blogWriter={blogWriter} setBlogWriter={setBlogWriter}
    blogContentTwo={blogContentTwo} setBlogContentTwo={setBlogContentTwo}
    blogImageOne={blogImageOne} setBlogImageOne={setBlogImageOne}
    setBlogImageTwo={setBlogImageTwo} blogImageTwo={blogImageTwo}
    addCoverImage={addCoverImage} addBannerImage={addBannerImage}
    addImageOne={addImageOne}  addImageTwo={addImageTwo}
    addBlog={addBlog}
    url={url} setUrl={setUrl}
         />

    </div>
  )
}

export default AddBlog